import {IUploadStoreState} from './IUploadStoreState';
import {prefix} from './thunks/config';

const filePrefix = `${prefix} uploadFile`;
const scormPrefix = `${prefix} uploadScorm`;
const webLinkPrefix = `${prefix} createWebLink`;

export const uploadExtraReducer = {
  [`${filePrefix}/fulfilled`]: (state: IUploadStoreState) => {
    state.file.page.loading = false;
    state.file.page.submitStatus = 'success';
  },
  [`${filePrefix}/pending`]: (state: IUploadStoreState) => {
    state.file.page.loading = true;
    state.file.page.submitStatus = 'pending';
  },
  [`${filePrefix}/rejected`]: (state: IUploadStoreState) => {
    state.file.page.loading = false;
    state.file.page.submitStatus = 'error';
  },

  [`${scormPrefix}/fulfilled`]: (state: IUploadStoreState) => {
    state.scormPackage.page.loading = false;
    state.scormPackage.page.submitStatus = 'success';
  },
  [`${scormPrefix}/pending`]: (state: IUploadStoreState) => {
    state.scormPackage.page.loading = true;
    state.scormPackage.page.submitStatus = 'pending';
  },
  [`${scormPrefix}/rejected`]: (state: IUploadStoreState) => {
    state.scormPackage.page.loading = false;
    state.scormPackage.page.submitStatus = 'error';
  },

  [`${webLinkPrefix}/fulfilled`]: (state: IUploadStoreState) => {
    state.webLink.page.loading = false;
    state.webLink.page.submitStatus = 'success';
  },
  [`${webLinkPrefix}/pending`]: (state: IUploadStoreState) => {
    state.webLink.page.loading = true;
    state.webLink.page.submitStatus = 'pending';
  },
  [`${webLinkPrefix}/rejected`]: (state: IUploadStoreState) => {
    state.webLink.page.loading = false;
    state.webLink.page.submitStatus = 'error';
  },
};
